import { z } from 'zod/v4';
export var TransactionAccountType;
(function (TransactionAccountType) {
    TransactionAccountType["BankAccount"] = "BANK_ACCOUNT";
    TransactionAccountType["PSP"] = "PSP";
})(TransactionAccountType || (TransactionAccountType = {}));
export const CreateTransactionAccountSchema = z.object({
    name: z.string(),
    type: z.enum(TransactionAccountType),
    referenceId: z.string().nullish(),
});
export const PatchTransactionAccountSchema = z.object({
    name: z.string().optional(),
    referenceId: z.string().nullish(),
});
//# sourceMappingURL=index.js.map